import {
  useStoreState,
  useStoreActions,
} from '@seller-hermes/hooks/easy-peasy';
import { Dialog, Row } from './dialogs.styles';
import Close from './close.component';
import { useCallback } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@seller-hermes/features/ui/Divider';
import SuggestDialogContent from './content.component';

const SuggestDialog = () => {
  const { isOpen } = useStoreState((s) => s.dialogs.suggest);
  const { close } = useStoreActions((s) => s.dialogs.suggest);
  const handleClose = useCallback(() => {
    close();
  }, [close]);
  return (
    <Dialog fullWidth open={isOpen} onClose={handleClose}>
      <Row>
        <DialogTitle>Sugestão</DialogTitle>
        <Close onClick={handleClose} />
      </Row>
      <Divider />
      <SuggestDialogContent close={handleClose} />
    </Dialog>
  );
};

export default SuggestDialog;
